import React, { memo } from 'react';
import QuantidadePapeisCardBase from '../../../../../components/organisms/EmpresaIndicadores/QuantidadePapeisCard';
import { useEmpresasContext } from '../../../../../contexts/EmpresasContext';

/** Adapta os dados contábeis da empresa para o card de quantidade de papéis. */
const QuantidadePapeisCard = memo(() => {
  const { state, actions } = useEmpresasContext();
  const xHistorico = state?.historico?.cs || [];

  return (
    <QuantidadePapeisCardBase
      pessoaNome={state?.pessoa?.pessoa_fantasia || state?.pessoa?.pessoa}
      historico={xHistorico}
      isLoading={state?.isPageLoading}
      actions={{
        formatNumber: (pValue, _pCurrency = false, pDecimals = 0) =>
          actions.formatNumber(pValue, state.showPrecise, false, pDecimals, null)
      }}
      onOpenHistory={actions.handleChartVariantChange}
    />
  );
});

QuantidadePapeisCard.displayName = 'QuantidadePapeisCard';

export default QuantidadePapeisCard;
